import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export const maskCurrency = createNumberMask({
  prefix: '$ ',
  allowDecimal: true,
  integerLimit: 5,
});
export const unmaskCurrency = (val) => {
  if (!val) {
    return 0;
  }
  if (!Number.isNaN(Number(val))) { return Number(val); }
  return Number(val.replace(/[$, ]+/g, ''));
};

export const maskPhoneNumber = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const matchPhoneNumber = /^\(*([1-9][0-9][0-9])\)*\s*[0-9][0-9][0-9]-*[0-9][0-9][0-9][0-9]$/;
export const unmaskPhoneNumber = (val) => val.replace(/[(-\s)]+/g, '');
export const maskedPhoneNumber = (number) => {
  if (!number) { return ''; }
  if (number.length !== 10) { return ''; }
  return `(${number.substring(0, 3)}) ${number.substring(3, 6)}-${number.substring(6, 10)}`;
};

export const maskZipCodes = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const matchZipCodes = /^\d{5}$/;

export const maskSSN1 = [/\d/, /\d/, /\d/];
export const matchSSN1 = /^\d{3}$/;
export const maskSSN2 = [/\d/, /\d/];
export const matchSSN2 = /^\d{2}$/;
export const maskSSN3 = [/\d/, /\d/, /\d/, /\d/];
export const matchSSN3 = /^\d{4}$/;
export const unmaskSSN = (val) => {
  if (!val) {
    return '';
  }
  return val.replace(/[_]+/g, '');
};

export const maskDateOfBirth = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
export const maskMonth = [/[0-1]/, /[0-9]/];
export const matchMonth = /[0-1][0-9]/;
export const maskDay = [/[0-3]/, /[0-9]/];
export const matchDay = /[0-3][0-9]/;
export const maskYear = [/[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];
export const matchYear = /[1-2][0-9][0-9][0-9]/;
export const unmaskDate = (val) => val.replace(/[_]+/g, '');
export const unmaskNumber = (val) => {
  if (!val) { return ''; }
  return val.match(/\d+/g).join('');
};
export const getMaxDay = (year, month) => {
  const monthMaxDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let maxDay = monthMaxDays[month - 1];
  if (year % 4 === 0 && month === 2) {
    maxDay = 29;
  }
  return maxDay;
};

export const matchEmail = (email) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
export const matchName = (name) => /^[a-zA-Z][a-zA-Z\s]*$/.test(name);
